import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { useParams } from 'react-router-dom';
import { OutboundSipTrunkResponse } from './types';
import { createOutboundSipTrunk, deleteOutboundSipTrunk, getOutboundSipTrunk, updateOutboundSipTrunk } from './api';

export function useGetOutboundSipTrunk(options?: UseQueryOptions<OutboundSipTrunkResponse, Error>) {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useQuery<OutboundSipTrunkResponse>({
    queryKey: ['outbound_sip_trunk', locationId, agentId],
    queryFn: () => getOutboundSipTrunk(locationId!, agentId!),
    enabled: Boolean(locationId && agentId),
    ...options
  });
}

export function useCreateOutboundSipTrunk() {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useMutation({
    mutationFn: (payload: any) => createOutboundSipTrunk(locationId!, agentId!, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['outbound_sip_trunk', locationId, agentId],
        refetchType: 'active'
      });
    }
  });
}

export function useUpdateOutboundSipTrunk() {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useMutation({
    mutationFn: (payload: any) => updateOutboundSipTrunk(locationId!, agentId!, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['outbound_sip_trunk', locationId, agentId],
        refetchType: 'active'
      });
    }
  });
}

export function useDeleteOutboundSipTrunk() {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useMutation({
    mutationFn: () => deleteOutboundSipTrunk(locationId!, agentId!),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['outbound_sip_trunk', locationId, agentId],
        refetchType: 'active'
      });
    }
  });
}
